import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './style.css';

export interface DialogBoxProps {
  title: string | undefined;
  content?: React.ReactNode;
  onSubmit?: () => void;
  onCancelCustomDisplay?: string;
  onSubmitCustomDisplay?: string;
  onCancel?: () => void;
  modalSize?: string;
  hasCustomButtons?: boolean;
}

// Define a custom type for the modal ref that exposes show and hide methods
export interface ModalHandle {
  show: () => void;
  hide: () => void;
}

export enum ModalWidth {
  narrow = 'narrow',
  wide = 'wide'
}

// Use React.forwardRef to correctly handle refs with ModalHandle type
const DialogBox = React.forwardRef<ModalHandle, DialogBoxProps>(
  (
    {
      title,
      content,
      onSubmit,
      onCancel,
      onSubmitCustomDisplay,
      onCancelCustomDisplay,
      hasCustomButtons
    },
    ref
  ) => {
    const [show, setShow] = React.useState(false);

    // Expose show and hide methods to the parent component
    React.useImperativeHandle(ref, () => ({
      show: () => setShow(true),
      hide: () => setShow(false)
    }));

    const handleClose = () => setShow(false);

    return (
      <>
        <Modal
          show={show}
          onHide={handleClose}
          centered
          backdrop="static"
          keyboard={false}
          className="backdrop"
        >
          <Modal.Dialog className="m-0 test">
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{content}</Modal.Body>
            {hasCustomButtons ? (
              <></>
            ) : (
              <Modal.Footer>
                <Button variant="secondary" onClick={onCancel || handleClose}>
                  {onCancelCustomDisplay ? onCancelCustomDisplay : 'Cancel'}
                </Button>
                <Button variant="primary" onClick={onSubmit || handleClose}>
                  {onSubmitCustomDisplay ? onSubmitCustomDisplay : 'Submit'}
                </Button>
              </Modal.Footer>
            )}
          </Modal.Dialog>
        </Modal>
      </>
    );
  }
);

export default DialogBox;
